module.exports = __webpack_public_path__ + "fonts/089dd517e350422c3eae8ff9d319d704.svg";